export default "__VITE_ASSET__DeoPStvB__"